import { Flex, Popover, Tag, Typography } from 'antd';
import { FC } from 'react';

import { AppCardList } from '@/common/components';
import { AppRoutes, BaseQueryParams } from '@/common/interfaces';

import { SiteGroup } from '@/modules/SiteGroups/entities';
import { useGetAllSiteGroupsQuery } from '@/modules/SiteGroups/queries';

const VISIBLE_SITES_COUNT = 6;

const SiteTag: FC<{ name: string }> = ({ name }) => (
  <Tag style={{ margin: 0, maxWidth: 180 }}>
    <Typography.Text ellipsis={{ tooltip: name }} style={{ maxWidth: '100%', fontSize: 'inherit' }}>{ name }</Typography.Text>
  </Tag>
);

const SiteGroupSites: FC<{ sites: SiteGroup['sites'] }> = ({ sites }) => {
  const hiddenSites = sites.slice(VISIBLE_SITES_COUNT);

  return (
    <Flex wrap gap={ 4 } style={{ marginBottom: 12 }}>
      { sites.slice(0, VISIBLE_SITES_COUNT).map((site) => <SiteTag key={ site.id } name={ site.name }/>) }

      { hiddenSites.length > 0 && (
        <Popover
          title={ `ще ${ hiddenSites.length }` }
          content={
            <Flex wrap gap={ 4 } style={{ maxWidth: 400, maxHeight: 240, overflowY: 'auto' }}>
              { hiddenSites.map((site) => <SiteTag key={ site.id } name={ site.name }/>) }
            </Flex>
          }
        >
          <Tag color="processing" style={{ margin: 0 }}>+{ hiddenSites.length }</Tag>
        </Popover>
      ) }
    </Flex>
  );
};

interface Props {
  currentPage: number;
  siteGroupsListItems: BaseQueryParams<typeof useGetAllSiteGroupsQuery>['data']['items'];
  siteGroupsListTotalItems: BaseQueryParams<typeof useGetAllSiteGroupsQuery>['data']['meta']['totalItems'];
  siteGroupsListItemsPerPage: BaseQueryParams<typeof useGetAllSiteGroupsQuery>['data']['meta']['itemsPerPage'];
  isLoading: boolean;
  handleChangePage: (page: number) => void;
}

export const SiteGroupsListView: FC<Props> = ({
  currentPage,
  siteGroupsListItems,
  siteGroupsListTotalItems,
  siteGroupsListItemsPerPage,
  isLoading,
  handleChangePage
}) => {
  return (
    <AppCardList
      headerTitle={ null }
      pagination={{
        current: currentPage,
        total: siteGroupsListTotalItems,
        pageSize: siteGroupsListItemsPerPage,
        disabled: isLoading,
        onChange: handleChangePage
      }}
      rowKey="id"
      titleKey="name"
      grid={{
        gutter: 16,
        xs: 1,
        sm: 1,
        md: 1,
        lg: 2,
        xl: 2,
        xxl: 2
      }}
      titleRender={ (name, { sites }) => (
        <>
          {name} <Typography.Text type="secondary" style={{ fontWeight: 'normal' }}>· { sites.length } сайт(ів)</Typography.Text>
        </>
      ) }
      content={ (record) => <SiteGroupSites sites={ record.sites }/> }
      navigateTo={ (record) => ({ to: AppRoutes.SiteGroupsById.replace(':siteGroupId', record.id) }) }
      list={ siteGroupsListItems }
    />
  );
};
